export default class MongoStripeBank {
  bank_name = "";
  country = "";
  last4 = "";
}
